module.exports = __webpack_public_path__ + "img/ic_arrow_bottom.df51d42a.svg";